import { T } from '@tribeplatform/react-components/i18n'
import { useRouter } from '@tribeplatform/react-sdk'

export const BillingFooter = () => {
  const { Link } = useRouter()

  return (
    <div className="text-content text-sm">
      <T
        defaultMessage="Have questions about billing? Email us at {email_address}"
        id="Admin.Billing.EmailUs"
        values={{
          email_address: (
            // eslint-disable-next-line react/jsx-no-literals
            <Link variant="accent" href="mailto:billing@bettermode.com">
              billing@bettermode.com
            </Link>
          ),
        }}
      />
    </div>
  )
}
